import { Transcript } from '.';

export interface ReplyAuthor {
  id: string;
  name: string;
  is_recipient: boolean;
  is_current_user: boolean;
}

export enum ReplyMediaStatus {
  RECEIVED = 'received',
  UPLOADED = 'uploaded',
  ENCODING = 'encoding',
  COMPLETE = 'complete',
  ERROR = 'error',
}

export interface ReplyMedia {
  id?: string;
  status: ReplyMediaStatus;
  video_url: string;
  thumb_url?: string;
  created_at?: string;
}

export interface Reply {
  id: string;
  content: string;
  author: ReplyAuthor;
  created_at: string;
  media?: ReplyMedia;
  transcript?: Transcript;
}
